import {mapActions, mapGetters, mapMutations} from "vuex";
import _ from "lodash";

export default {
    name: 'news',
    components: {},
    data() {
        return {
            checkedFilter: false,
            sort: {},
            selectFilter:{
                orderBy:'asc'
            }
        }
    },

    computed: {
        ...mapGetters({
            getNews: 'home/news',
            getSortNews: 'home/sortNews'
        })
    },
    methods: {
        checkFilter() {
            return this.checkedFilter = !this.checkedFilter
        },
        ...mapActions({
            fetchNews: 'home/NEWS',
        }),
        selectFilters() {

            let params = _.assign(this.$route.query,  this.selectFilter)

            history.pushState(
                {},
                null,
                this.$route.path + '?' + Object.keys(params)
                    .map(key => {
                        return (
                            encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
                        )
                    })
                    .join('&')
            )
            this.sendRequest()



        },
        sendRequest: _.debounce(function () {

            this.fetchNews(this.$route.query);

        }, 300)
    },
    created() {
        this.selectFilters()
    },

}
